import { render, staticRenderFns } from "./CoffeeMug.vue?vue&type=template&id=3891e3f0"
import script from "./CoffeeMug.vue?vue&type=script&lang=js"
export * from "./CoffeeMug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports